module.exports = __webpack_public_path__ + "static/img/35cf828fba589015fe825eb691136e9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/T11.jpg
// module id = CGcB
// module chunks = 1